import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Observable, Subscription, fromEvent, interval } from 'rxjs';
import { debounce } from 'rxjs/operators';

@Component({
  selector: 'app-input-with-spinner',
  templateUrl: './input-with-spinner.component.html',
  styleUrls: ['./input-with-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  exportAs: "value",
  viewProviders: [ { provide: ControlContainer, useExisting: NgForm } ],
  imports: [CommonModule, MatProgressSpinnerModule, FormsModule]
})
export class InputWithSpinnerComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges{

  constructor(private selfRef : ElementRef, private changeDetectorRef : ChangeDetectorRef)
  {}


  @Input()
  showSpinner  = false;

  @Input()
  spinnerPosition  = "flex-start"

  @Input()
  spinnerColor  = "var(--clr-svea-1)"

  @Input()
  spinnerDiameter  = 30;

  @Input()
  autoUpdateSpinnerSize  = true;

  @Input()
  clearOnLoading  = true;

  @Input()
  value : string;

  @Input()
  name = `input-${Math.floor(10000 + Math.random() * 90000)}`;

  @Input()
  readonly  = false;

  @Output()
  valueChange : EventEmitter<string> = new EventEmitter<string>();

  resizeWindowObservable$ : Observable<any>;
  resizeWindowSubscription$ :  Subscription;

  ngOnInit(): void {
    if (this.autoUpdateSpinnerSize)
    {
      this.resizeWindowObservable$ = fromEvent(window, 'resize').pipe(debounce(() => interval(250)));
      this.resizeWindowSubscription$ = this.resizeWindowObservable$.subscribe( evt => {
        this.sizeSpinners()
      })
    }

  }


  ngOnDestroy(): void {
    this.resizeWindowSubscription$?.unsubscribe();
  }

  ngAfterViewInit(): void {
    if (this.autoUpdateSpinnerSize)
      {this.sizeSpinners(); }

  }

  ngOnChanges(changes : SimpleChanges)
  {
    if (changes.showSpinner)
    {

      if (changes.showSpinner.currentValue == true && this.clearOnLoading)
      {
        this.value = "";
        this.valueChange.emit(this.value);
      }
    }
  }

  sizeSpinners()
  {
    const inputHeight = (this.selfRef.nativeElement as HTMLElement).getElementsByTagName('input')[0].offsetHeight;
    this.spinnerDiameter = inputHeight  - 16; // 16 seems to look good on all tested sizes, no other reason for this value

    this.changeDetectorRef.markForCheck();

  }

  checkForChanges()
  {
    this.changeDetectorRef.detectChanges();
  }

}
